import gql from 'graphql-tag';
import { apollo } from 'src/features';

const mutation = gql`
mutation CreateCaseFromActivity($activityId: ID!, $requestTypeId: ID!, $case: CaseInput!) {
  createCase(activityId: $activityId, requestTypeId: $requestTypeId, case: $case) {
    id
    name
    description
    insertedAt
    updatedAt
    comment
  }
}`;

function createCaseFromActivity(activityId, requestTypeId, caseInput) {
  return apollo.client.mutate({
    variables: {
      activityId,
      requestTypeId,
      case: {
        ...caseInput,
        status: 'OPENED',
      },
    },
    mutation,
  }).then((res) => {
    const info = res.data.createCase;
    return {
      id: activityId,
      case: {
        id: info.id,
        name: info.name,
        description: info.description,
        insertedAt: new Date(info.insertedAt),
        updatedAt: new Date(info.updatedAt),
        comment: info.comment,
      },
    };
  });
}

export default createCaseFromActivity;
